import { render, staticRenderFns } from "./download_form.vue?vue&type=template&id=0dc8c40d&scoped=true"
import script from "./download_form.vue?vue&type=script&lang=js"
export * from "./download_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc8c40d",
  null
  
)

export default component.exports